import React from "react";
import PongGame3D from "../components/PongGame3D";
import PongGame from "@/components/PongGame";
import { useSearchParams } from "react-router-dom";

function PongPage() {
  const [searchParams] = useSearchParams();
  const urlMode = searchParams.get("mode");
  const dimension = searchParams.get("dimension");

  if (urlMode === "AI" && dimension === "3D") {
    return <PongGame3D />;
  }

  if (urlMode === "AI" && dimension === "2D") {
    return <PongGame />;
  }

  if (urlMode === "LOCAL") {
    return <PongGame />; 
  }


  return <div>Invalid game setup</div>;
}

export default PongPage;
